import type { CollectionSummaryJSONObject, TagJSONObject } from '@ikegps/core-api';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import { TagState } from '../../page/tag.state';
import { AppStore } from '../../store';
import { CollectionCard } from './collection.card';
import { buildVariantRows } from './collection.variant.group';
import { VariantCard } from './variant.card';

/**
 * Renders a parent pole that has variants: the parent itself is the container header (a normal,
 * selectable job-list card), followed by its read-only variant rows indented beneath it —
 * "Existing" first, then each published variant. Variant summaries load lazily by uuid.
 */
export const VariantContainer = {
	view(state: TagState, tag: TagJSONObject, parent: CollectionSummaryJSONObject): MithrilVNode {
		const rows = buildVariantRows(parent, (uuid) => AppStore.CollectionSummary.getFetchableByUuid(uuid).value);
		const variantRows = rows.map((row) => VariantCard.view(state, tag, row, parent.revision));
		return m('div', { key: 'vc-' + parent.uuid }, [CollectionCard.view(state, tag, parent, true), ...variantRows]);
	},
};
